import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui';

import * as Styled from './MassActions.styles';

export const MassActions = ({ items }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <Styled.Wrapper className="massActions">
      <Button variant="outlined" color="secondary" onClick={(event) => setAnchorEl(event.currentTarget)}>
        Masowe działania
      </Button>

      {!!anchorEl && (
        <Styled.Popover
          open
          onClose={() => setAnchorEl(null)}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <Styled.DropdownContent>
            <Styled.Menu>
              {items.map((item) => (
                <Styled.MenuButton
                  key={item.key}
                  onClick={() => {
                    setAnchorEl(null);
                    item.onClick();
                  }}
                >
                  {item.label}
                </Styled.MenuButton>
              ))}
            </Styled.Menu>
          </Styled.DropdownContent>
        </Styled.Popover>
      )}
    </Styled.Wrapper>
  );
};

MassActions.propTypes = {
  items: PropTypes.array.isRequired,
};
